import { render, staticRenderFns } from "./ExpandablePayouts.vue?vue&type=template&id=f80f625e&scoped=true"
import script from "./ExpandablePayouts.vue?vue&type=script&lang=js"
export * from "./ExpandablePayouts.vue?vue&type=script&lang=js"
import style0 from "./ExpandablePayouts.vue?vue&type=style&index=0&id=f80f625e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80f625e",
  null
  
)

export default component.exports